import { render, staticRenderFns } from "./SegmentsEditor.vue?vue&type=template&id=1c09cec8&"
import script from "./SegmentsEditor.vue?vue&type=script&lang=js&"
export * from "./SegmentsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports